import { render } from "./FieldIndicator.vue?vue&type=template&id=3f621771&scoped=true"
import script from "./FieldIndicator.vue?vue&type=script&lang=js"
export * from "./FieldIndicator.vue?vue&type=script&lang=js"

import "./FieldIndicator.vue?vue&type=style&index=0&id=3f621771&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f621771"]])

export default __exports__